import { Link } from "react-router-dom";
import { AlertTriangle, RotateCcw } from "lucide-react";

/** Shown while any ELPM voice needs re-making (found by the daily check or a failed song), until it's re-made. */
export default function VoiceHealthBanner({ voices }) {
  const broken = (voices || []).filter((v) => v.status === "broken");
  if (!broken.length) return null;
  return (
    <section data-testid="voice-health-banner" className="rounded-3xl border border-amber-300/35 bg-amber-400/[0.08] p-4">
      <p className="flex items-start gap-2 text-[13px] font-semibold text-amber-100">
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
        {broken.length === 1 ? `Your ELPM voice “${broken[0].name}” needs re-making` : `${broken.length} ELPM voices need re-making`}
      </p>
      <p className="mt-1 pl-6 text-[12px] leading-relaxed text-white/60">The music engine can't sing with {broken.length === 1 ? "it" : "them"} any more, so songs in {broken.length === 1 ? "that voice" : "those voices"} would fail. Re-make takes about 2 minutes — or pick V6 for now.</p>
      <div className="mt-3 flex flex-wrap gap-2 pl-6">
        {broken.map((v) => (
          <Link key={v.id} to={`/create/my-voices/elpm/${v.id}`} data-testid={`voice-health-remake-${v.id}`} className="inline-flex items-center gap-1.5 rounded-full bg-amber-300 px-4 py-1.5 text-[12px] font-semibold text-black transition-transform duration-200 hover:scale-[1.02]">
            <RotateCcw className="h-3.5 w-3.5" /> Re-make {broken.length > 1 ? `“${v.name}”` : "voice"}
          </Link>
        ))}
      </div>
    </section>
  );
}
